import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// Actions
import {
  setData,
  fetchShippingTypeRates,
  setFieldInformation,
} from "../actions/checkoutStore";

import { setLoader } from "../redux/ui";

// Components
import { LoadingIcon } from "./LoadingIcon";
import StepsTemplate from "../templates/stepsTemplate";
import ShippingContent from "./ShippingContent";
import CheckStep from "../utils/CheckStep";

export default function Shipping() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);

  const isFirstRun = useRef(true);
  const mediaWatcher = window.matchMedia("(max-width: 992px)");

  function changeStoreInformationField(field, value) {
    dispatch(setFieldInformation(field, value));
  }

  function updateMobile() {
    changeStoreInformationField("is_mobile", mediaWatcher.matches);
  }

  useEffect(() => {
    let link = "";
    if (state.checkoutStore && state.checkoutStore.information) {
      link = "/shipping/shipping_data";
    } else if (!state.checkoutStore.shipping) {
      link = "/information/information_data";
    }

    axios({
      headers: {
        common: {
          "Content-Type": "application/json",
        },
      },
      method: "get",
      url: window.base_url + link,
      params: { recover_token: window.token },
    })
      .then((response) => {
        dispatch(setData(response.data));
        dispatch(
          setLoader({
            state: false,
            feature: "FETCH_DATA_SHIPPING",
          }),
        );
        if (
          response.data.info?.shipping_option == "delivery" ||
          state.checkoutStore.information.shipping_option == "delivery"
        )
          response.data.shipping.available_shipping_method_types.forEach(
            (type) => {
              dispatch(fetchShippingTypeRates(type));
            },
          );
      })
      .catch(() => {
        dispatch(
          setLoader({
            state: false,
            feature: "FETCH_DATA_SHIPPING",
          }),
        );
      });
  }, []);

  useEffect(() => {
    if (isFirstRun.current) {
      if (mediaWatcher.addEventListener) {
        mediaWatcher.addEventListener("change", updateMobile);
      } else {
        mediaWatcher.addListener(updateMobile);
      }

      isFirstRun.current = false;
      return;
    }
  }, [state.checkoutStore.information]);

  if (state.ui.isLoading || !state.checkoutStore.shipping) {
    return <LoadingIcon default />;
  }

  const currentUrl = window.location.href;
  const redirectUrl = CheckStep(state, currentUrl);
  if (redirectUrl) navigate(redirectUrl);

  return (
    <StepsTemplate>
      <ShippingContent />
    </StepsTemplate>
  );
}
